import { use$ } from '@legendapp/state/react';
import { useTheme } from '@volkswagen-onehub/components-core';
import styled from 'styled-components';

import { dragOverlayStore } from '../../../../store';

const ANIMATION_LENGTH = '5s';
const ITERATIONS = '4';
const INITIAL_DELAY = '2s';

const useCreateSvg = (animationName: string) => {
	const isDragAnimationFinished = use$(dragOverlayStore.isDragAnimationFinished);
	const { variant } = useTheme();
	const arrowColor = variant === 'v26' ? '#1B2236' : '#001E50';
	const arrowActiveColor = variant === 'v26' ? '#1B2236' : '#0040c5';
	const carColor = variant === 'v26' ? '#1B2236' : '#001E50';
	const carActiveColor = variant === 'v26' ? '#1B2236' : '#0040c5';
	const animations = getAnimations({ arrowColor, arrowActiveColor, carColor, carActiveColor });

	// @TODO sooo bad
	const { styles, pathStyles = '', keyframes } = animations[animationName]!;

	if (isDragAnimationFinished) {
		return styled.svg`
			${styles};
		`;
	}

	return styled.svg`
		${styles};
		animation: ${ANIMATION_LENGTH} ease-in-out ${INITIAL_DELAY} ${ITERATIONS} ${animationName};
		${pathStyles} @keyframes ${animationName} {
			${keyframes}
		}
	`;
};

export default useCreateSvg;
const getAnimations = ({
	arrowColor,
	arrowActiveColor,
	carColor,
	carActiveColor
}: {
	arrowColor: string;
	arrowActiveColor: string;
	carColor: string;
	carActiveColor: string;
}): Record<string, { keyframes: string; styles: string; pathStyles?: string }> => ({
	hand: {
		keyframes: `
			0% { scale: 1; }
			10% { scale: 0.8; transform: translateY(-52%); }
			20% { transform: translateX(-20%) translateY(-52%) rotateZ(3deg); }
			40% { scale: 0.8; transform: translateX(70%) translateY(-52%) rotateZ(-10deg); }
			50% { scale: 0.8; transform: translateX(50%) translateY(-52%) rotateZ(-10deg); }
			55% { scale: 1; transform:  translateY(5%) }
		`,
		styles: `
			position: absolute;
			left: 37.5%;
			top: 82%;
		`
	},
	arrow: {
		keyframes: `
			10% { fill: ${arrowActiveColor}; }
			12% { fill: ${arrowActiveColor}; transform: translateX(-50%) rotateZ(1deg); }
			21% { fill: ${arrowActiveColor}; transform: translateX(-58%) rotateZ(3deg); }
            40% { transform: translateX(-40%) rotateZ(-3deg); fill: ${arrowActiveColor}; }
            50%{fill: ${arrowActiveColor}; transform: translateX(-50%)}
            60%{fill: ${arrowColor}; transform: translateX(-50%)}
		`,
		styles: `
			position: absolute;
			top: 60%;
			left: 50%;
			transform: translateX(-50%);
			stroke: ${arrowColor};
            fill:${arrowColor};
		`
	},
	car: {
		keyframes: `
			10% { stroke: ${carActiveColor}; fill: ${carActiveColor}; }
			25% { stroke: ${carActiveColor}; fill: ${carActiveColor}; }
			50% { stroke: ${carActiveColor}; fill: ${carActiveColor}; }
            60% {stroke: ${carColor};fill:${carColor}; }
		`,
		styles: `
			position: absolute;
			left: 50%;
			transform: translateX(-50%);
			top: 0;
			color: ${carColor};
		`,
		pathStyles: `& path {
				stroke: ${carColor};
				fill: ${carColor};
                animation: ${ANIMATION_LENGTH} ease-in-out ${INITIAL_DELAY} ${ITERATIONS} car;

			}`
	},
	lines: {
		keyframes: `
			10% { stroke: ${arrowActiveColor}; }
			25% { stroke: ${arrowActiveColor}; }
			50% { stroke: ${arrowActiveColor}; }
            60% {stroke: ${arrowColor}; }
		`,
		styles: `
			position: absolute;
			left: 50%;
			transform: translateX(-50%);
			top: 0;
			color: ${arrowColor};
		`,
		pathStyles: `& path {
				stroke: ${arrowColor};
                animation: ${ANIMATION_LENGTH} ease-in-out ${INITIAL_DELAY} ${ITERATIONS} lines;
			}`
	}
});
